import { memo } from 'react';

import { getPathBGByIndex } from '../../../../constants/pathBackground';
import { AppBar, StationCell, StationCellProps } from '../../../Molecules';
import './AlbumPathListTemplate.css';

export type AlbumPathListTemplateProps = {
  pathStyleBackground: number;
  albumName?: string;
  stations: StationCellProps[];
};

export const AlbumPathListTemplate = memo(
  ({
    pathStyleBackground,
    stations,
    albumName,
  }: AlbumPathListTemplateProps) => {
    const albumIcon = getPathBGByIndex(pathStyleBackground);

    return (
      <div
        className="album-path-list"
        style={{
          backgroundImage: `url(${albumIcon})`,
        }}
      >
        <AppBar title={albumName} />
        <div className="centered-container">
          <div className="path-list-view">
            {stations.map((item, index) => (
              <StationCell key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
    );
  },
);
